import styled from "styled-components";

import { windowWidth } from "@styles/global";

const Container = styled.div`
  padding: 0 30px 50px 30px;

  > :not(:last-child) {
    margin-bottom: 15px;
  }
`;

export { Container };
